import { render, staticRenderFns } from "./DormitoryChange.vue?vue&type=template&id=3a2c9f70&scoped=true"
import script from "./DormitoryChange.vue?vue&type=script&lang=js"
export * from "./DormitoryChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c9f70",
  null
  
)

export default component.exports